"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.zonesForPositionInList_Destination = exports.zoneDescription = exports.zonesDeserialize = exports.zoneDeserialize = void 0;
const sortBy_1 = __importDefault(require("lodash/sortBy"));
const filterBoolean_1 = __importDefault(require("../util/filterBoolean"));
const CoordinatesArray_1 = require("./CoordinatesArray");
const deserializeArray_1 = __importDefault(require("./deserializeArray"));
const deserializeBoolean_1 = __importDefault(require("./deserializeBoolean"));
const deserializeObject_1 = __importDefault(require("./deserializeObject"));
const deserializeString_1 = require("./deserializeString");
const PositionInList_1 = __importDefault(require("./PositionInList"));
function zoneDeserialize(value) {
    const object = (0, deserializeObject_1.default)(value);
    return {
        id: (0, deserializeString_1.deserializeString)(object.id),
        name: (0, deserializeString_1.deserializeString)(object.name),
        allowsPickup: (0, deserializeBoolean_1.default)(object.allowsPickup),
        allowsDropOff: (0, deserializeBoolean_1.default)(object.allowsDropOff),
        coordinates: (0, CoordinatesArray_1.coordinatesArrayDeserialize)(object.coordinates),
    };
}
exports.zoneDeserialize = zoneDeserialize;
exports.zonesDeserialize = (0, deserializeArray_1.default)(zoneDeserialize);
function zoneDescription(zone) {
    return `${zone.name} (${(0, filterBoolean_1.default)([zone.allowsPickup && 'pickup', zone.allowsDropOff && 'drop-off']).join(' and ') +
        (zone.allowsPickup && zone.allowsDropOff ? '' : ' only')})`;
}
exports.zoneDescription = zoneDescription;
function zonesForPositionInList_Destination(zones, position, destination) {
    let results;
    switch (position) {
        case PositionInList_1.default.first:
            results = zones.filter(zone => { var _a; return zone.allowsPickup && ((_a = destination === null || destination === void 0 ? void 0 : destination.zoneIds.includes(zone.id)) !== null && _a !== void 0 ? _a : true); });
            break;
        case PositionInList_1.default.last:
            results = zones.filter(zone => { var _a; return zone.allowsDropOff && ((_a = destination === null || destination === void 0 ? void 0 : destination.zoneIds.includes(zone.id)) !== null && _a !== void 0 ? _a : true); });
            break;
        default:
            results = zones.filter(zone => { var _a; return zone.allowsPickup && ((_a = destination === null || destination === void 0 ? void 0 : destination.zoneIds.includes(zone.id)) !== null && _a !== void 0 ? _a : true); });
            break;
    }
    return (0, sortBy_1.default)(results, 'name');
}
exports.zonesForPositionInList_Destination = zonesForPositionInList_Destination;
